import AttendanceData from "../backend/dataservices/AttendanceData";
import {Button, Grid, TableCell} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React from "react";

class TableUtils {


    static states = [
        {name: "Beantragt"},
        {name: "Angemeldet"},
        {name: "Warteliste"},
        {name: "Bestätigt"},
        {name: "Eingeladen"},
        {name: "Teilgenommen"},
        {name: "Storniert"}
    ];

    static handleStatusChangerChange(event, row) {
        let value = event.target.value;
        if (row.type === 'plannedAttendance') {
            if (value === 'Angemeldet'
                || value === 'Eingeladen'
                || value === 'Teilgenommen'
                || value === 'Storniert'
                || value === 'Bestätigt') {
                if(row.date == null || row.date === '' || row.date.length <= 4) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    static changeState(event, row, newValue) {
        if (row.type === 'plannedAttendance') {
            return AttendanceData.updatePlannedAttendance(row.attendanceID, newValue);
        } else {
            return AttendanceData.changeAttendanceState(row.attendanceID, newValue)
        }
    }

    static getTypes() {
        return ['Erhaltungsmaßnahme', 'Weiterbildung'];
    }

    static findPlannedAtts(courseID, employeeID, attsSet) {
        let oldList = [];
        attsSet.forEach(array => {
            array.forEach(v => {
                oldList.push(v);
            })
        });
        let filteredAtts = TableUtils.getFilteredAtts(oldList);
        for (const index in filteredAtts) {
            let value = filteredAtts[index];
            if(value != null) {
                if (value["M_Pers-Nr"] === employeeID) {
                    if (value.KS_ID === courseID) {
                            return value;
                    }
                }
            }
        }
        return null;
    }

    static getTableCell(courseID, employeeID, employeeName, courseName, attsSet, handleTableCellClick, setStateOnClick) {
        let atts = TableUtils.findPlannedAtts(courseID, employeeID, attsSet);
        let year;
        let status;
        let attendanceID;
        if (atts != null) {
            year = atts._type === 'plannedAttendance' ?
                atts.KA_Datum.substring(0, 4) : atts.KD_Anfangstag.substring(0, 4);
            status = atts._type === 'plannedAttendance' ? atts.KA_Status : atts.KV_Statustext;
            attendanceID = atts._type === 'plannedAttendance' ? atts.KA_ID : atts.KV_ID;
        }
        return <TableCell align={"left"} sx={{border: '1px solid lightgrey', padding: 0}} key={courseID.toString() + employeeID.toString()}>
            <Button fullWidth sx={{padding: 0}} onClick={() => {
                if (atts != null) {
                    handleTableCellClick(courseID, employeeID, employeeName, courseName, status, year, attendanceID);
                } else {
                    let data = {
                        gid: employeeID,
                        courseID: courseID,
                        employeeName: employeeName,
                        courseName: courseName
                    }
                    setStateOnClick(data);
                }
            }}>
                {atts != null ?
                    <Grid container alignContent={'center'} alignItems={'center'} bgcolor={TableUtils.getColor(status)}
                          color={"black"} padding={0} height={50}>
                        <Grid item xs={12}>
                            {status}
                        </Grid>
                        <Grid item xs={12}>
                            {
                                year}
                        </Grid>
                    </Grid>

                    :
                    <Grid container alignContent={'center'} alignItems={'center'} padding={0}>
                        <Grid item xs={12} padding={0}>
                            <AddIcon/>
                        </Grid>
                        <Grid item xs={12} padding={0} height={'100%'}>
                        </Grid>
                    </Grid>
                }
            </Button>
        </TableCell>
    }

    static getFilteredAtts(attsSet) {
        let list = attsSet;
        let toDelete = [];
        list.forEach(function (value1) {
            list.forEach(function (value2) {
                if (value1["M_Pers-Nr"] === value2["M_Pers-Nr"]
                    && value1.KS_ID === value2.KS_ID
                    && ((value1._type === 'plannedAttendance' && value2._type === 'plannedAttendance' && value1.KA_ID !== value2.KA_ID)
                    || (value1._type === 'attendance' && value2._type === 'attendance' && value1.KV_ID !== value2.KV_ID)
                    || (value1._type !== value2._type))) {
                    let date1 = new Date(value1._type === 'plannedAttendance' ? value1.KA_Datum : value1.KD_Anfangstag);
                    let date2 = new Date(value2._type === 'plannedAttendance' ? value2.KA_Datum : value2.KD_Anfangstag);
                    if (date1 < date2) {
                        toDelete.push(value1)
                    } else if (date1 > date2) {
                        toDelete.push(value2);
                    }
                }
            });
        });

        let newList = [];

        list.forEach(function (value, index, arr) {
            let found = false;
            toDelete.forEach(function (delValue, delIndex, delArr) {
                if (value._type === delValue._type) {
                    if(value._type === 'plannedAttendance') {
                        if(value.KA_ID === delValue.KA_ID) {
                            found = true;
                        }
                    } else {
                        if(value.KV_ID === delValue.KV_ID) {
                            found = true;
                        }
                    }
                }
            });
            if (!found) {
                newList.push(value);
            }
        });

        return newList;
    }

    static getColor(status) {
        if (status === 'Geplant')
            return '#fabebe';
        else if (status === "Angemeldet")
            return "#FEBE8C";
        else if (status === "Beantragt")
            return "#FFFBC1";
        else if(status === "Bestätigt")
            return "#B6E2A1";
        else
            return "#88ce6e";
    }

    static durationFormatter(_value) {
        // Die Dauer haengt am Kursstamm; ist sie dort nicht gepflegt, darf in der
        // Tabelle kein "null Stunden" stehen -- gleiche Konvention wie dateFormatter.
        if (_value.KS_Dauer == null) {
            return '-'
        }
        return `${_value.KS_Dauer} Stunden`
    }

    static dateFormatter(_value) {
        let _type = _value._type
        let value;

        if(_type === 'attendance') {
            // console.log(_value);
            value = [_value.KD_Anfangstag, _value.KD_Letzter_Tag, _value.KD_Beginn, _value.KD_Ende];
        } else {
            value = _value.KA_Datum;
        }

        let dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' }
        // let timeOptions = {hour: '2-digit', minute:'2-digit'}

        if (_type === 'plannedAttendance') {
            dateOptions = { year: 'numeric' }
            const date = new Date(value)
            return `${date.toLocaleDateString('de-DE', dateOptions)}`
        }

        if (value[0] == null || value[1] == null) {
            return '-'
        }

        const begin = new Date(value[0])
        const end = new Date(value[1])
        // const beginTime = value[2] == null ? '' : ' ' + new Date(value[2]).toLocaleTimeString('de-DE', timeOptions);
        // const endTime = value[3] == null ? '' : ' ' + new Date(value[3]).toLocaleTimeString('de-DE', timeOptions);
        // console.log(beginTime);
        // console.log(endTime);
        let date = `${begin.toLocaleDateString('de-DE', dateOptions)} - ${end.toLocaleDateString('de-DE', dateOptions)}`;
        // console.log('Return ' + date);
        return date
    }
}

export default TableUtils;
